import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import {PanelItem} from '../../../components'
import {Link} from '../index'
import Typography from 'material-ui/Typography'

const styles = theme => ({
  Label: {
    cursor: 'pointer',
    transition: 'linear 100ms color',
    '&:hover': {
      color: theme.palette.primary.light,
    },
  },
})

const FlowSummaryPanelItem = ({classes, title, description, actionLabel, error, warning, onClick, disabled, ...props}) => (
  <PanelItem {...props} button={true} onClick={onClick}>
    <div style={{flex: 1}}>
      <Typography variant={'body2'}>{title}</Typography>
      <Typography variant={'body1'} color={'textSecondary'} style={error ? {color: 'red'} : warning ? {color: 'orange'} : undefined}>
        {description}
      </Typography>
    </div>
    <div style={{alignSelf: 'flex-start'}}>
      <Link onClick={onClick}>{actionLabel}</Link>
    </div>
  </PanelItem>
)

FlowSummaryPanelItem.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  actionLabel: PropTypes.string.isRequired,
  error: PropTypes.bool,
  warning: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
}

FlowSummaryPanelItem.defaultProps = {
  onClick: () => {},
  disabled: false,
}

export default withStyles(styles, {withTheme: true})(FlowSummaryPanelItem)



// WEBPACK FOOTER //
// ./src/sections/flow/components/flowSummaryPanelItem.jsx